import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getSetting, setSetting, settingKeys } from '../../../utils/settings';
import { DEFAULT_XML_EXPORT_OPTIONS, downloadOpenLyricsFile } from '../../../utils/openLyricsExport';
import ToggleSwitch from '../../common/ToggleSwitch';
import SettingsModal from '../../common/SettingsModal';
import ModalButton from '../../common/ModalButton';

// Each one's label and hint are under dialogs.exportXml, by name
const TOGGLES = ['repeatSlashes', 'writeDuplicates', 'chords', 'comments'];

// Stored as one object; spread over the defaults so an option added later starts at its default
const readOptions = () => ({ ...DEFAULT_XML_EXPORT_OPTIONS, ...getSetting(settingKeys.xmlExportOptions) });

const ExportXmlModal = ({ isOpen, onClose, song }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState(readOptions);

  const handleToggle = (name) => {
    const next = { ...options, [name]: !options[name] };

    setOptions(next);
    setSetting(settingKeys.xmlExportOptions, next);
  };

  const handleExport = () => {
    downloadOpenLyricsFile(song, options);
    onClose();
  };

  return (
    <SettingsModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('dialogs.exportXml.title')}
      className="ExportXmlModal"
      footer={<ModalButton onClick={handleExport}>{t('dialogs.exportXml.export')}</ModalButton>}
    >
      {TOGGLES.map((name) => (
        <ToggleSwitch
          key={name}
          name={`xml-export-${name}`}
          label={t(`dialogs.exportXml.${name}`)}
          checked={options[name]}
          onChange={() => handleToggle(name)}
          description={t(`dialogs.exportXml.${name}Hint`)}
          showOnOffText={true}
        />
      ))}
    </SettingsModal>
  );
};

ExportXmlModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  song: PropTypes.object.isRequired,
};

export default ExportXmlModal;
